/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fetchV2} from '../api'

export const useMutationFetchV2 = createReactQueryMutationHook('fetchV2', fetchV2)
